import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Grid, Stack, TextField, useMediaQuery } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
export default function MediaControlCard(props) {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Card sx={{ display: 'flex', margin: 2, justifyContent: matchDownMd ? 'center' : 'left' }} elevation={3}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Stack direction="column">
                        <Grid container>
                            <Stack direction={matchDownMd ? 'column' : 'row'} alignItems="center">
                                <Grid item sm={12} md={2}>
                                    <CardMedia component="img" sx={{ width: 80, height: 80 }} image={props.image} alt={props.alt} />
                                </Grid>
                                <Grid item sm={12} md={4}>
                                    <CardContent>
                                        {/* <Typography component="div" variant="h5">
                        Live From Space
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary" component="div">
                        Mac Miller
                    </Typography> */}
                                        {props.Body}
                                    </CardContent>
                                </Grid>
                                <Grid item sm={12} md={6}>
                                    <CardContent>
                                        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1, minWidth: 100 }}>
                                            {/* <IconButton aria-label="play/pause">
                        <PlayArrowIcon sx={{ height: 38, width: 38 }} />
                    </IconButton> */}

                                            <TextField
                                                size="small"
                                                id={props.key}
                                                variant="outlined"
                                                type="number"
                                                value={props.value}
                                                onChange={props.onChange}
                                                inputProps={{ min: 0, style: { textAlign: 'center', minWidth: 30 } }}
                                            />
                                            <Stack>
                                                <IconButton aria-label="next" onClick={props.onClickPlus}>
                                                    <AddCircleOutlineIcon />
                                                </IconButton>
                                                <IconButton aria-label="previous" onClick={props.onClickMinus}>
                                                    <RemoveCircleOutlineIcon />
                                                </IconButton>
                                            </Stack>
                                            <Stack direction="row" spacing={3} alignItems="right">
                                                <IconButton
                                                    color="error"
                                                    onClick={props.onClickDelete}
                                                    sx={{ marginLeft: matchDownMd ? 1 : 1 }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Stack>
                                        </Box>
                                    </CardContent>
                                </Grid>
                            </Stack>
                        </Grid>
                    </Stack>
                </Box>
        </Card>
    );
};
